import { Gem } from "lucide-react";

export function Brand({ compact = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className="h-9 w-9 rounded-xl btn-gold flex items-center justify-center gold-glow">
        <Gem size={18} className="text-[#0B0F12]" />
      </div>
      <div className="leading-tight">
        <div className="font-display text-base font-800 gold-text tracking-wide">JJS</div>
        {!compact && <div className="text-[10px] uppercase tracking-[0.25em] text-slate-400 -mt-0.5">Engagement</div>}
      </div>
    </div>
  );
}

export function PoweredBy() {
  return (
    <p className="text-center text-[11px] text-slate-500 tracking-wide">
      Powered by <span style={{ color: "#264194" }} className="font-semibold">Smartsevak</span>
    </p>
  );
}

export function Overline({ children }) {
  return <div className="text-xs uppercase tracking-[0.2em] font-semibold text-amber-400/90">{children}</div>;
}

export function Stat({ label, value, icon: Icon, testid }) {
  return (
    <div className="glass rounded-2xl p-4 card-lift" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-xs text-slate-400 uppercase tracking-wide">{label}</span>
        {Icon && <Icon size={16} className="text-amber-400/80" />}
      </div>
      <div className="font-display text-3xl mt-2 gold-text">{value}</div>
    </div>
  );
}

export function PriorityBadge({ priority }) {
  const map = {
    hot: "bg-red-500/15 text-red-300 border-red-500/40",
    warm: "bg-amber-500/15 text-amber-300 border-amber-500/40",
    cold: "bg-sky-500/15 text-sky-300 border-sky-500/40",
  };
  const p = priority || "—";
  return (
    <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full border ${map[priority] || "bg-slate-500/15 text-slate-300 border-slate-500/40"}`} data-testid="lead-card-priority-badge">
      {p}
    </span>
  );
}

export function Spinner() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="h-8 w-8 rounded-full border-2 border-amber-500/30 border-t-amber-400 animate-spin" />
    </div>
  );
}
